<template>
  <div id="qvo-app">
    <titlebar />
    <navbar />
    <notificationCenter />
    <main id="content" class="select-tenant">
      <h1>Select a Tenant</h1>
      <div>You can access the following client systems:</div>
      <template v-if="tenantList">
        <ul class="tenant-list">
          <li v-if="isAdmin()" class="tenant-option tenant-option-master">
            <v-btn
              text
              @click="onSetTenant('master')"
              title="Select Master"
              label="Select Master"
            >
              <div class="tenant-option-name">
                <img
                  class="qvo-logo"
                  alt="Quavo Admin"
                  src="@/assets/imgs/qvo-logo-color.svg"
                />
                <template v-if="activeTenantId === 'master'">
                  <v-icon class="current-tenant"> mdi-check-circle </v-icon>
                </template>
              </div>
              <div class="tenant-option-id">master</div>
            </v-btn>
          </li>
          <li
            class="tenant-option"
            v-for="tenant in tenantList"
            :key="tenant.tenantId"
          >
            <v-btn
              text
              @click="onSetTenant(tenant.tenantId)"
              :title="'Select ' + tenant.tenantLabel"
              :label="'Select ' + tenant.tenantLabel"
            >
              <div class="tenant-option-name">
                {{ tenant.tenantLabel }}
                <template v-if="tenant.tenantId === activeTenantId">
                  <v-icon class="current-tenant"> mdi-check-circle </v-icon>
                </template>
              </div>
              <div class="tenant-option-id">{{ tenant.tenantId }}</div>
            </v-btn>
          </li>
        </ul>
      </template>
    </main>
    <footnote />
  </div>
</template>

<script>
/**
 * @fileoverview select-tenant.vue allows an admin user to select a tenant from a list of available tenants.
 * It relies on vuex to map the state variables from the store files.
 *
 * @author David Barnett <david.barnett@quavo.com>
 */

import { mapState } from "vuex";

export default {
  name: "select-tenant",
  computed: {
    ...mapState({
      loggedInUser: (state) => state.account.loggedInUser,
      loggedInUserId: (state) => state.account.loggedInUserId,
      tenantList: (state) => state.account.tenantList,
      activeTenantId: (state) => state.account.activeTenantId
    }),
  },
  methods: {
    isAdmin() {
      return this.tenantList.some(tenant=>tenant.tenantId=='master');
    },
    /**
     * Set the active tenant based on the user selection. Clear data artifacts after selection.
     * @param {String} tenantId - the selected tenantId
     */
    onSetTenant(tenantId) {
      // Perform the switch
      this.$store.dispatch("setActiveTenant", tenantId).then(() => {
        // State Cleanup
        this.$store.dispatch("clearAccountState");
        this.$store.dispatch("clearConfigState");
      });
    },
  },
  created() {
    this.$store.dispatch("getTenantList", this.activeTenantId);
  },
};
</script>

<!-- Page-Specific Style Import (don't edit here) -->
<style lang="scss">
@import "@/design/views/select-tenant.scss";
</style>

